module.exports = __webpack_public_path__ + "img/gack.71b8ac05.png";